import { DataTable } from '../../../components/UI/MDC/DataTable/DataTable';
import styles from '../IMSLDAPValidator.module.scss';
import { nanoid } from 'nanoid';

const HRData = hrDataResults => {
	const headers = [
		{
			Value: 'Registered for HRDirect (MyHub)/Infonet',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'Peoplesoft OU Entry Exists *',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'Peoplesoft OU On-Prem Entry Exists *',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'Infonet OU Entry Exists *',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'HRDirect (MyHub) OID Entry Exists',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'OrclSecondaryUID Attribute Exists',
			props: { sort: null, onSortChange: null },
		},
		{ Value: 'HR Data in IMS', props: { sort: null, onSortChange: null } },
	];

	const getColor = value => {
		if (value === 'No' || value === 'Bad' || value === 'Error') {
			return 'red';
		} else if (value === 'Yes' || value === 'Good') {
			return 'green';
		}
		return 'black'; // Default color
	};

	const rows = Object.entries(hrDataResults).map(([key, data]) => {
		return {
			Cells: {
				'Registered for HRDirect (MyHub)/Infonet': {
					Value: (
						<span
							style={{ color: getColor(data.RegisteredInMyHub) }}
						>
							<strong>{data.RegisteredInMyHub}</strong>
						</span>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Peoplesoft OU Entry Exists *': {
					Value: (
						<span style={{ color: getColor(data.PSFTEntryExists) }}>
							<strong>{data.PSFTEntryExists}</strong>
						</span>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Peoplesoft OU On-Prem Entry Exists *': {
					Value: (
						<span style={{ color: getColor(data.PSFTEntryExists) }}>
							<strong>{data.PSFTEntryExists}</strong>
						</span>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'Infonet OU Entry Exists *': {
					Value: (
						<span
							style={{ color: getColor(data.InfnetEntryExists) }}
						>
							<strong>{data.InfnetEntryExists}</strong>
						</span>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'HRDirect (MyHub) OID Entry Exists': {
					Value: (
						<span
							style={{
								color: getColor(data.MyHubOIDEntryExists),
							}}
						>
							<strong>{data.MyHubOIDEntryExists}</strong>
						</span>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'OrclSecondaryUID Attribute Exists': {
					Value: (
						<span
							style={{
								color: getColor(
									data.OracleSecondaryUIDAttribute
								),
							}}
						>
							<strong>{data.OracleSecondaryUIDAttribute}</strong>
						</span>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				'HR Data in IMS': {
					Value: (
						<span style={{ color: getColor(data.HRDataInIMS) }}>
							<strong>{data.HRDataInIMS}</strong>
						</span>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: nanoid(),
		};
	});

	return (
		<DataTable
			rows={rows}
			headers={headers}
			className={styles.Table_Overrides}
		/>
	);
};

export default HRData;
